// extracted by mini-css-extract-plugin
export default {"heading":"Kv-z","corrected":"Lv-z","redirectVerbiageContainer":"Mv-z","redirectVerbiageText":"Nv-z"};